export class ItemImageLink {
  Wholesaler: number;
  InternalItemNumber: number;
  ItemGroupNumber: number;
  ImageId: string;
  Filename: string;
  ImageUrl: string;
}